import { render, staticRenderFns } from "./DashboardTodayOrders.vue?vue&type=template&id=12012a0f"
import script from "./DashboardTodayOrders.vue?vue&type=script&lang=js"
export * from "./DashboardTodayOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports